import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AdalService, AdalInterceptor } from 'adal-angular4';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';

import { AppRoutingModule } from './app-routing.module';
import { AngularMaterialModule } from './shared/angular-material.module';
import { ChartsModule } from 'ng2-charts';

import { AppComponent } from './app.component';
import { ActivityTimelineComponent } from './activitity/activity-timeline/activity-timeline.component';
import { AccountDetailComponent } from './account/account-detail/account-detail.component';
import { AccountWizardComponent } from './account/account-wizard/account-wizard.component';
import { AccountListComponent } from './account/account-dashboard/account-dashboard-list/account-dashboard-list.component';
import { AccountArchivedComponent } from './account/account-archived/account-archived.component';
import { AccountDashboardComponent } from './account/account-dashboard/account-dashboard.component';
import { TitleComponent } from './shared/title/title.component';
import { PieChartComponent } from './account/account-dashboard/account-dashboard-charts/pie-chart/pie-chart.component';
import { ConfirmDialogComponent } from './shared/modals/confirm/confirm-dialog.component';
import { ImageDialogComponent } from './shared/image-grid/image-grid-dialog/image-dialog.component';
import { AccountExpansionTableComponent } from './account/shared/account-expansion-table/account-expansion-table.component';
import { GroupByPipe } from './shared/pipes/group-by.pipe';
import { FilterPipe } from './shared/pipes/filter.pipe';
import { ActivityTimelineCardComponent } from './activitity/activity-timeline/activity-timeline-card/activity-timeline-card.component';
import { LineChartComponent } from './account/account-dashboard/account-dashboard-charts/line-chart/line-chart.component';
import { AccountDashboardChartsComponent } from './account/account-dashboard/account-dashboard-charts/account-dashboard-charts.component';
import { AccountDetailFormComponent } from './account/account-detail/account-detail-form/account-detail-form.component';
import { AccountWizardFormComponent } from './account/account-wizard/account-wizard-form/account-wizard-form.component';
import { FileInputComponent } from './shared/file-input/file-input.component';
import { LoadingDialogComponent } from './shared/modals/loading/loading-dialog.component';
import { ImageGridComponent } from './shared/image-grid/image-grid.component';

import localeJa from '@angular/common/locales/ja';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeJa);

@NgModule({
  declarations: [
    AppComponent,
    ActivityTimelineComponent,
    AccountDetailComponent,
    AccountWizardComponent,
    AccountListComponent,
    AccountArchivedComponent,
    AccountDashboardComponent,
    TitleComponent,
    PieChartComponent,
    ConfirmDialogComponent,
    AccountExpansionTableComponent,
    GroupByPipe,
    FilterPipe,
    ImageDialogComponent,
    ActivityTimelineCardComponent,
    LineChartComponent,
    AccountDashboardChartsComponent,
    AccountDetailFormComponent,
    AccountWizardFormComponent,
    FileInputComponent,
    LoadingDialogComponent,
    ImageGridComponent,
  ],
  entryComponents: [
    ImageDialogComponent,
    ConfirmDialogComponent,
    LoadingDialogComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    FlexLayoutModule,
    ChartsModule,
    HammerModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'ja' },
    AdalService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AdalInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
